import React, { useEffect, useContext } from 'react';
import { StoreContext } from '../context/StoreContext';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import Helmet from '../components/Helmet';
import SpaListing from '../components/SpaListing';

const SpaDayLocationListingTemplate = ({
  data: {
    spaseekers: {
      spaDayLocation: {
        locationId,
        locationType,
        seo,
        dataLayer,
        breadcrumbs,
        name,
        images,
        topContent,
        initialResults,
        contentBlocks,
        otherLocations,
      },
    },
  },
  location,
}) => {
  const { triggerCjAffiliatePageView } = useContext(StoreContext);

  useEffect(() => {
    triggerCjAffiliatePageView(locationId ? 'subCategory' : 'category');
  }, []);

  return (
    <Layout dataLayer={dataLayer}>
      <Helmet seo={seo} ogImage={images && images[0]} />
      <main>
        <SpaListing
          locationData={location}
          heading={seo.h1}
          breadcrumbs={breadcrumbs}
          location={{
            id: locationId,
            type: locationType,
            name: name,
            url: seo.url,
          }}
          content={{ topContent: topContent }}
          initialResults={initialResults}
          options={{
            searchType: 'Days',
          }}
          contentBlocks={contentBlocks}
          otherLocations={otherLocations}
        />
      </main>
    </Layout>
  );
};

export const SpaDayLocationListingTemplateQuery = graphql`
  query SpaDayLocationListingTemplateQuery($id: Int!, $page: Int) {
    spaseekers {
      spaDayLocation(locationID: $id, page: $page) {
        locationId
        locationType
        seo {
          ...HelmetFragment
          h1
        }
        dataLayer {
          ...DataLayerFragment
        }
        breadcrumbs {
          ...BreadcrumbsFragment
        }
        name
        images {
          ...ImageFragment
        }
        topContent
        initialResults {
          data {
            ...SpaCardFragment
          }
          meta {
            ...SpaListingMetaFragment
          }
        }
        contentBlocks {
          ...ModularBlocksFragment
        }
        otherLocations {
          ...OtherSpaLocationsFragment
        }
      }
    }
  }
`;

export default SpaDayLocationListingTemplate;
